import {createApp} from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import 'bootstrap';
import {createI18n} from 'vue-i18n/index';
import messages from "./locales/translations";
import Maska from 'maska';
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

const i18n = createI18n({
    legacy: false,
    locale: 'fr', // set locale
    fallbackLocale: 'fr', // set fallback locale
    localeDir: 'locales',
    messages, // set locale messages
    globalInjection: true,
});

createApp(App).use(i18n).use(store).use(router).use(Maska).component('Datepicker', Datepicker).mount('#app');
